import { useState } from 'react';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

interface SectionHeightProps {
  item: ComponentSettingsTab['item'];
  onChange: ComponentSettingsTab['onChange'];
}

const SectionHeight = ({ item, onChange }: SectionHeightProps) => {
  const [displayHeightInput, setDisplayHeightInput] = useState(
    Boolean(item?.attributes?.height),
  );

  const removeHeightValue = () => {
    onChange({
      id: item.id,
      values: [
        {
          settingKey: 'attributes.height',
          value: undefined,
        },
        {
          settingKey: 'attributes.verticalAlign',
          value: undefined,
        },
      ],
    });

    setDisplayHeightInput(false);
  };

  if (!displayHeightInput) {
    return null;
  }

  return (
    <>
      <NumberSetting
        disabled
        item={item}
        onChange={onChange}
        settingKey="height"
        title={__('Height')}
      />

      <Box mb={2}>
        <AdditionalInformation
          iconName="circle-info"
          id={item.id}
          mt={0}
          type="info"
        >
          <Box flexDirection="column">
            <Box as="p">
              {s__('Builder|The Height option is deprecated.')} <br />
              {s__(
                'Builder|Please remove the Height and readjust your layout with paddings and alignment if needed.',
              )}
            </Box>
            <FakeLink onClick={removeHeightValue} mt={1}>
              {s__('Builder|Remove the Height permanently.')}
            </FakeLink>
          </Box>
        </AdditionalInformation>
      </Box>
    </>
  );
};

export default SectionHeight;
